import * as angular from 'angular';
import { ManageUsersEditPermissionsModalCtrl } from './manage-users-edit-permissions-modal.controller';
import { ManageUsersEditPermissionsModal } from './manage-users-edit-permissions-modal.service';

export const ManageUsersEditPermissionsModalModule = angular
  .module('manageUsersEditPermissionsModal', [])
  .controller('ManageUsersEditPermissionsModalCtrl', ManageUsersEditPermissionsModalCtrl)
  .service('ManageUsersEditPermissionsModal', ManageUsersEditPermissionsModal).name;
